import { ANIMATED_STYLE } from "src/libs/interfaces/animated";
import { IAnimate } from "../data/interfaces";
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "../data/store";

export function useAnimatedStyle( data: IAnimate, order: number) : string {
    const isEdit = useLandingConsoleStore((state: ILandingConsoleStore) => state.isEdit)
    const currentLanding = useLandingStore((state: ILandingStore) => state.currentLanding)
    if( isEdit || !!currentLanding.isLockAnimation) 
    {
        return ""
    }
    
    const animated: ANIMATED_STYLE[] = Array.isArray(data?.animated) 
        ? 
        [...data.animated] 
        : 
        !!data?.animated ? [ data.animated ] : [ ANIMATED_STYLE.FADE_IN ]
    const anim = animated[order % animated.length]
    const animate   = typeof anim !== "undefined" && anim !== ANIMATED_STYLE.NONE 
        ?
        `animate  ${anim} `
        :
        "" 
    return animate
}